// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"721":"26725442","9078":"18c503c9"}[chunkId] || chunkId) + "." + {"721":"88eefc0107fcb0da","2938":"440e82a02d737f73","4316":"dcffe9980dbf6620","7736":"5190b95654c32e0b","9078":"2503e4e83de5042b"}[chunkId] + ".js";
};